import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
// Components
import StepsExplained from '../shared/organisms/StepsExplained';
import DisplayShop from './DisplayShop';

const CompactStepsExplained = styled(StepsExplained)`
  @media (max-width: ${(p) => p.theme.breakpoints.md}) {
    h6 {
      font-size: 1em !important;
      margin-bottom: 6px !important;
    }
    p {
      font-size: 0.875em !important;
      line-height: 1.4 !important;
    }
  }
`;

const InfosComponents = ({
  shops,
  isInZone,
  refs,
  indexShopClick,
  annuaire,
  horsZoneAnnuaire = false,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {isInZone && (
        <CompactStepsExplained
          mt={{ xs: 6, lg: 9 }}
          headings={[
            t('how.headings.3'),
            t('how.headings.5'),
            t('how.headings.7'),
          ]}
          texts={[
            t('how.contents.1'),
            t('how.contents.2'),
            t('how.contents.3'),
          ]}
        />
      )}
      {shops.length > 0 && (
        <DisplayShop
          {...{ shops, refs, indexShopClick, annuaire, horsZoneAnnuaire }}
        />
      )}
    </>
  );
};

export default InfosComponents;
